import React, {Component} from 'react';
import { Tabs } from 'antd';
import layouts from '../../layouts';
import services from '../../services';
import Chart from '../../components/Chart';
import HomeTeacher from './teacher/HomeTeacher';
import Home from './Home';

const { TabPane } = Tabs;

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statistics: {
                "orgCount": 0,
                "majorCount": 0,
                "academicCount": 0,
                "teacherCount": 0,
                "classesCount": 0,
                "courseCount": 0,
                "studentCount": 0
            },

            analysis: {},
            
            todolist: [],
        }
    }

    componentDidMount() {
    }

    render() {
        const props = this.props;
        const { statistics, todolist, analysis } = this.state;
        return (
            <layouts.ViewPort>
                 <Tabs tabPosition={"right"}>
                    <TabPane tab="默认主页" key="1">
                        <Home></Home>
                    </TabPane>
                    <TabPane tab="教师主页" key="2">
                        <HomeTeacher></HomeTeacher>
                    </TabPane>
                 </Tabs>
            </layouts.ViewPort>
            
        );
    }
}

export default HomePage;
